import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import NavBar from "../../../Components/Navbar/NavBar";
import Sales from "./SalesKT";
import Reports from "./ReportsKT";
import About from "./AboutKT";
import kt_logo from "../../../Assets/kt_logo.svg";

function KT() {
  const [selectedOption, setSelectedOption] = useState("Sales");

  const handleTabClick = (tab) => {
    setSelectedOption(tab);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <Sales content="Sales KT" color="red" />;
      case "Reports":
        return <Reports content="Reports KT" />;
      case "About":
        return <About content="About KT" />;
      default:
        return <Sales content="Sales KT" color="red" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar
        tabIndicatorColor="red.600"
        logo={kt_logo}
        onTabClick={handleTabClick}
      />

      <Box bg="white" w="100%" h="calc(100vh - 60px)" overflow="hidden">
        {renderContent()}
      </Box>
    </Box>
  );
}

export default KT;
